import script from "./PasswordRecovery.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&setup=true&lang=js"

import "./PasswordRecovery.vue?vue&type=style&index=0&id=bc707044&lang=css"

const __exports__ = script;

export default __exports__